import { getRootDeputyFrame } from '@webapp-next/global-libs/deputy-embed';

export default function getDpAnalytics() {
  return getRootDeputyFrame()?.dpAnalytics || mockDpAnalytics;
}

const mockDpAnalytics = {
  sendAnalyticEvent: () => {},
  EventScreen: {},
  EventName: {},
};
